/** Transient dashboard preferences, shared by the toolbar dialog and node menus. */
export class ConnectionDashboardSettings {
  private _showNodeFilter = false;
  private _showConnectionGrabs = true;
  constructor(private readonly onChange: () => void) {}
  get showNodeFilter(): boolean { return this._showNodeFilter; }
  get showConnectionGrabs(): boolean { return this._showConnectionGrabs; }
  set showConnectionGrabs(value: boolean) {
    if (this._showConnectionGrabs === value) return;
    this._showConnectionGrabs = value;
    this.onChange();
  }
  set showNodeFilter(value: boolean) {
    if (this._showNodeFilter === value) return;
    this._showNodeFilter = value;
    this.onChange();
  }
}

export const CONNECTION_DASHBOARD_OPTIONS = [
  { id: "connectionDashboardFuses", title: "Sicherungen" },
  { id: "connectionDashboardActors", title: "Aktoren" },
  { id: "connectionDashboardTerminals", title: "Klemmen" },
  { id: "connectionDashboardDistributions", title: "Unterverteilungen" },
  { id: "connectionDashboardConsumers", title: "Consumer" },
  { id: "connectionDashboardScenes", title: "Szenen & Multiplexer" },
  { id: "connectionDashboardButtons", title: "Taster" },
] as const;

export type ConnectionDashboardId = typeof CONNECTION_DASHBOARD_OPTIONS[number]["id"];

/** Restores older projects to the original three trees and normalizes saved selections. */
export function normalizeConnectionDashboardSelection(value: unknown): ConnectionDashboardId[] {
  if (!Array.isArray(value)) return ["connectionDashboardActors", "connectionDashboardConsumers", "connectionDashboardButtons"];
  const result: ConnectionDashboardId[] = [];
  for (const option of CONNECTION_DASHBOARD_OPTIONS) {
    // Accept saved column IDs from before the dashboard rename.
    const legacyId = option.id.replace("connectionDashboard", "multiTree");
    if (value.includes(option.id) || value.includes(legacyId)) result.push(option.id);
  }
  return result;
}
